import { render, staticRenderFns } from "./faceSignPopup.vue?vue&type=template&id=84be4abe&scoped=true"
import script from "./faceSignPopup.vue?vue&type=script&lang=ts"
export * from "./faceSignPopup.vue?vue&type=script&lang=ts"
import style0 from "./faceSignPopup.vue?vue&type=style&index=0&id=84be4abe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84be4abe",
  null
  
)

export default component.exports